import { render } from "./FolderStar.vue?vue&type=template&id=b7b17018"
import script from "./FolderStar.vue?vue&type=script&setup=true&lang=js"
export * from "./FolderStar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/FolderStar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7b17018"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7b17018', __exports__)) {
    api.reload('b7b17018', __exports__)
  }
  
  module.hot.accept("./FolderStar.vue?vue&type=template&id=b7b17018", () => {
    api.rerender('b7b17018', render)
  })

}


export default __exports__